import React from 'react';

import { Master, Visa } from './components';
import { Container } from './Watermark.styles';

import { CreditCardType, Size, Variant } from '../../types';

export type Props = {
  type: CreditCardType;
  size: Size;
};

const Watermark = ({ type, size }: Props) => {
  const variant = `${type}-${size}`;
  if (type === 'visa')
    return (
      <Container variant={variant as Variant}>
        <Visa />
      </Container>
    );
  if (type === 'master')
    return (
      <Container variant={variant as Variant}>
        <Master />
      </Container>
    );

  return null;
};

export default Watermark;
